const faqSection = document.querySelector('.faq')
if (faqSection) {
    const faqBlocks = document.querySelectorAll('.faq__block');

    if (faqBlocks.length) {
        const firstBlock = faqBlocks[0];
        const firstBtn = firstBlock.querySelector('.faq__button');
        const firstPanel = firstBtn.nextElementSibling;

        firstBlock.classList.add('active');
        firstBtn.classList.add('active');
        firstPanel.style.maxHeight = firstPanel.scrollHeight + "px";

        faqBlocks.forEach(block => {
            block.addEventListener("click", () => {
                const btn = block.querySelector('.faq__button');
                const panel = btn.nextElementSibling;

                const isActive = block.classList.contains('active');

                faqBlocks.forEach(b => {
                    b.classList.remove('active');
                    b.querySelector('.faq__button').classList.remove('active');
                    b.querySelector('.faq__button').nextElementSibling.style.maxHeight = null;
                });

                if (!isActive) {
                    block.classList.add('active');
                    btn.classList.add('active');
                    panel.style.maxHeight = panel.scrollHeight + "px";
                }
            });
        });
    }
}

